export enum QueryKeys {
  GET_COUNTRY_HOLIDAYS = 'GET_COUNTRY_HOLIDAYS',
  GET_DRIVERS_DISTRICT_LIST = 'GET_DRIVERS_DISTRICT_LIST',
  GET_DRIVERS_DISTRICT_LIST_BY_ID = 'GET_DRIVERS_DISTRICT_LIST_BY_ID',
  GET_DRIVERS_LIST = 'GET_DRIVERS_LIST',
  GET_DRIVER_WINDOW_SLOTS = 'GET_DRIVER_WINDOW_SLOTS',
  GET_WEEKDAY_WINDOWS_ALL = 'GET_WEEKDAY_WINDOWS_ALL',
  GET_WEEKDAY_WINDOWS_FOR_SLOT = 'GET_WEEKDAY_WINDOWS_FOR_SLOT',
  GET_DRIVER_HOLIDAYS = 'GET_DRIVER_HOLIDAYS',
  GET_DISTRICTS_DRIVER_LIST = 'GET_DISTRICTS_DRIVER_LIST',
  GET_AVAILABLE_PROVIDERS = 'GET_AVAILABLE_PROVIDERS',
  GET_USERS = 'GET_USERS',
  GET_USER_META = 'GET_USER_META',
  GET_PAYMENT_TYPES = 'GET_PAYMENT_TYPES',
  GET_ORDER_HISTORY = 'GET_ORDER_HISTORY',
  CALC_ORDER_PRICE = 'CALC_ORDER_PRICE',
  GET_ORDERS = 'GET_ORDERS',
  GET_META = 'GET_META',
  GET_BLOCKED_DRIVERS = 'GET_BLOCKED_DRIVERS',
  GET_STATUSES = 'GET_STATUSES',
  GET_ORDER_BY_ID_WITH_DRIVERS_WAREHOUSES = 'GET_ORDER_BY_ID_WITH_DRIVERS_WAREHOUSES',
  GET_ORDER_LIST_BY_ID_WITH_DRIVERS_WAREHOUSES = 'GET_ORDER_LIST_BY_ID_WITH_DRIVERS_WAREHOUSES',
  GET_DISTRICT_SCHEDULE_AND_WORKLOAD = 'GET_DISTRICT_SCHEDULE_AND_WORKLOAD',
  GET_USER_DEPARTMENTS = 'GET_USER_DEPARTMENTS',
  GET_CURRENT_USER_DEPARTMENTS = 'GET_CURRENT_USER_DEPARTMENTS',
  GET_COUNTRIES_BY_DEPARTMENT_ID = 'GET_COUNTRIES_BY_DEPARTMENT_ID',
  GET_DRIVERS_WITH_LAST_TRACK_POINT = 'GET_DRIVERS_WITH_LAST_TRACK_POINT',
  GET_DRIVERS_WITH_ADDRESS_BY_DATE = 'GET_DRIVERS_WITH_ADDRESS_BY_DATE',
  GET_DRIVERS_WORKLOAD = 'GET_DRIVERS_WORKLOAD',
  GET_COUNTRY_HOLIDAYS_BY_DEPARTMENT_ID = 'GET_COUNTRY_HOLIDAYS_BY_DEPARTMENT_ID',
  GET_ORDER_COMMENTS = 'GET_ORDER_COMMENTS',
  GET_DRIVERS_WITH_DISTRICTS_LEGACY = 'GET_DRIVERS_WITH_DISTRICTS_LEGACY',
  GET_DISTRICTS_WITH_DRIVERS_LEGACY = 'GET_DISTRICTS_WITH_DRIVERS_LEGACY',
  GET_CLIENT_PHONE = 'GET_CLIENT_PHONE',
  GET_DRIVER_TRACK_POINTS = 'GET_DRIVER_TRACK_POINTS',
  GET_DRIVER_ORDER_CHANGES = 'GET_DRIVER_ORDER_CHANGES',
}
